import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/material.module';


// components
import { TranslateModule } from '@ngx-translate/core';
import { CookieConsentBottomSheetComponent } from './components/cookie-consent-bottom-sheet/cookie-consent-bottom-sheet.component';

@NgModule({
  declarations: [CookieConsentBottomSheetComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    TranslateModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule,
    CookieConsentBottomSheetComponent
  ]
})
export class SharedModule { }
